import { View } from 'react-native';
import { SafeAreaView as SafeAreaViewImport } from 'react-native-safe-area-context';

export const SafeAreaView: typeof SafeAreaViewImport = View as unknown as typeof SafeAreaViewImport;
